<template>
  <div class="site-rich-text-wrapper">
    <template v-if="disabled && value">
      <div class="rich-text-preview" v-html="value"></div>
    </template>
    <template v-else>
      <site_rich_text
        :id="editorId"
        :value="currentValue"
        :toolbars="toolbars"
        :height="height"
        :width="'100%'"
        @change="onChange"
        @input="onChange"
        ref="rich"
      />
    </template>
  </div>
</template>

<script>
const DEFAULT_TOOLBARS = [
  'bold', 'italic', 'underline', 'removeformat',
  'forecolor', 'backcolor',
  'insertorderedlist', 'insertunorderedlist',
  'justifyleft', 'justifycenter', 'justifyright',
  'fontfamily', 'fontsize',
  'lineheight',
  'link', 'unlink',
  'inserttable', 'deletetable',
  'undo', 'redo',
  'cleardoc'
]

export default {
  name: 'SiteRichText',
  props: {
    value: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    toolbars: { type: Array, default: () => DEFAULT_TOOLBARS },
    height: { type: String, default: '400px' }
  },
  data() {
    return {
      currentValue: this.value || '',
      editorId: 'editor_' + Date.now() + '_' + Math.random().toString(36).substr(2, 8)
    }
  },
  watch: {
    value(val) {
      if (val !== this.currentValue) {
        this.currentValue = val || ''
      }
    }
  },
  methods: {
    onChange(val) {
      this.currentValue = val
      this.$emit('input', val)
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.site-rich-text-wrapper {
  width: 100%;
  ::v-deep .edui-default .edui-editor {
    overflow: visible;
  }
}
.rich-text-preview {
  padding: 16px;
  background: #f6f9fc;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  min-height: 80px;
  line-height: 1.7;
  color: #4e5969;
}
</style>
